import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';
import FieldError from '../../../../shared/fields-errors/field-error';

const GetMusallaDetailDialog = (props) => {
    const { register, watch, setError, clearErrors, formState: { errors } } = useFormContext();
    const fieldsWatcher = watch();
    const [show, setShow] = useState(props?.show);
    const navigate = useNavigate();

    //content properties
    const [dialogTitle, setDialogTitle] = useState("Musalla Details");

    const handleCancel = () => {
       navigate("/special-products");
    }
    const closeDialog = () => {
        if(fieldsWatcher?.goal_amount > 0 && fieldsWatcher?.price_per_unit > 0)
        {
            clearErrors()
            props?.setShow(false);
            setShow(false);
        }
        else{
            if(fieldsWatcher?.goal_amount <= 0){
                setError('goal_amount', { type: 'manual', message: 'No of Musalla is Required.' });
            }
            if(fieldsWatcher?.price_per_unit <= 0){
                setError('price_per_unit', { type: 'manual', message: 'Amount is Required.' });
            }
        }
    }


    useEffect(() => {
        setShow(!!props?.show);
    }, [props?.show]);


    return (
        <Modal
            keyboard={false}
            centered
            size="md"
            backdrop="static" show={show} onHide={closeDialog} animation={true}>
            <div className='d-flex justify-content-between p-3'>
                <Modal.Title>{dialogTitle}</Modal.Title>
            </div>
            <Modal.Body>
                <div className='col-12 card mt-3'>
                    <div className='card-body'>
                        <div className="form-group"><label className="form-control-label text-black text-bold" >
                            Total Musalla
                        </label><input
                                {...register("goal_amount")}
                                placeholder="Enter the total no of musalla at your masjid"
                                type="number" className="form-control-alternative form-control" />
                        </div>
                        {errors?.goal_amount ? <FieldError message={errors?.goal_amount?.message} /> : ''}
                    </div>
                </div>
                <div className='col-12 card mt-3'>
                    <div className='card-body'>
                        <div className="form-group">
                            <label className="form-control-label text-black text-bold" >
                                Amount Per Musalla
                            </label>
                            <input
                                {...register("price_per_unit", {
                                    validate: {
                                        required: value => {
                                            if (!value) return 'Amount is required';
                                            return true;
                                        },
                                        min: value => {
                                            if (value <= 0) {
                                                return `Amount cannot be less then or equal to 0`
                                            };
                                            return true;
                                        }
                                    }
                                })}
                                placeholder="Maintenance cost of each musalla per year"
                                type="number" className="form-control-alternative form-control" />
                        </div>
                        {errors?.price_per_unit ? <FieldError message={errors?.price_per_unit?.message} /> : ''}
                    </div>
                </div>
            </Modal.Body>
            <div className='p-3 text-right'>
                <Button variant='primary' className='me-2' onClick={handleCancel}>
                    Cancel
                </Button>
                <Button variant='primary' className='me-2' onClick={closeDialog}>
                    Confirm
                </Button>
            </div>
        </Modal>
    );
}

export default GetMusallaDetailDialog;